__turbopack_context__.v({
  "btnRequest": "styles-module-scss-module__Rg3fBa__btnRequest",
  "buttonWrapper": "styles-module-scss-module__Rg3fBa__buttonWrapper",
  "content": "styles-module-scss-module__Rg3fBa__content",
  "list": "styles-module-scss-module__Rg3fBa__list",
  "loginButton": "styles-module-scss-module__Rg3fBa__loginButton",
  "page": "styles-module-scss-module__Rg3fBa__page",
  "recaptcha": "styles-module-scss-module__Rg3fBa__recaptcha",
  "root": "styles-module-scss-module__Rg3fBa__root",
  "step": "styles-module-scss-module__Rg3fBa__step",
  "submenuOptOut": "styles-module-scss-module__Rg3fBa__submenuOptOut",
  "text": "styles-module-scss-module__Rg3fBa__text",
  "title": "styles-module-scss-module__Rg3fBa__title",
});
